import { useEffect, useCallback } from "react";

const ImageLightbox = ({ src, alt, onClose }) => {
  const handleKeyDown = useCallback((e) => {
    if (e.key === "Escape") {
      onClose();
    }
  }, [onClose]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    // Prevent body scroll when lightbox is open
    document.body.style.overflow = "hidden";
    
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.overflow = "";
    };
  }, [handleKeyDown]);

  return (
    <div 
      className="image-lightbox" 
      onClick={onClose}
      data-testid="image-lightbox"
    >
      <button 
        className="image-lightbox-close"
        onClick={onClose}
        title="Close (Esc)"
      >
        ✕
      </button>
      <img 
        src={src} 
        alt={alt} 
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
};

export default ImageLightbox;
